'use strict';
const angular = require('angular');

/*@ngInject*/
export function hasDayFilter() {
  return function(input, query) {
    // let daysList = query.split(',');
    // console.log(query);
    // console.log(input);
    let daysList = query;
    input = input || '';
    let out = [];
    for(let value of input) {
      if(!value.days && (value.dayOf || value.dayOf === 0)) {
        value.days = [value.dayOf];
      }
      let pass = false;
      for(var i = 0; i < daysList.length; i++) {
        if(value.days && value.days.indexOf(daysList[i]) > -1) {
          pass = true;
        }
      }
      if(pass) {
        out.push(value);
      }
    }
    return out;
  };
}

export default angular.module('fiapiApp.hasDay', [])
  .filter('hasDay', hasDayFilter)
  .name;



// WEBPACK FOOTER //
// ./client/filters/hasDay/hasDay.filter.js